<form class="flex items-center gap-1" [formGroup]="formGroup()">
  <p-checkbox
    [formControl]="formGroup().controls.czyAdresZagraniczny"
    [binary]="true"
    [inputId]="`czyAdresZagraniczny-${schoolAddress() ? '-szkola' : ''}`"
    styleClass="customCheckbox"
  />
  <label
    [for]="`czyAdresZagraniczny-${schoolAddress() ? '-szkola' : ''}`"
    class="ml-2 my-4"
    >Adres zagraniczny</label
  >
</form>
@if (formGroup().controls.czyAdresZagraniczny.value === true) {
  <app-form-foreign-address
    [formGroup]="formGroup().controls.adresZagraniczny!"
    [schoolAddress]="schoolAddress()"
  ></app-form-foreign-address>
} @else {
  <app-form-domestic-address
    [formGroup]="formGroup().controls.adres!"
    [schoolAddress]="schoolAddress()"
  ></app-form-domestic-address>
}
